"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeSchemaIn = void 0;
class EventTypeSchemaIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeSchemaIn.attributeTypeMap;
    }
}
exports.EventTypeSchemaIn = EventTypeSchemaIn;
EventTypeSchemaIn.discriminator = undefined;
EventTypeSchemaIn.attributeTypeMap = [
    {
        "name": "schema",
        "baseName": "schema",
        "type": "any",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeSchemaIn.js.map